export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  function modifyTitle(data) {
    const text = data.items[0].Title;
    const title = $(`#${widgetName} span.card-widget-title`);
    title[0].outerHTML = `<h1 class="card-widget-title" aria-label="${text}">${text}</h1>`;
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      if (data.items.length < 1) {
        $('.seo-section').remove();
      } else {
        modifyTitle(data);
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'LEARN MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
